<template>
  <g>
    <!-- fibers -->
    <g class="fibers">
      <g class="fiber-1-side-a">
        <!-- widespread -->
        <path
          :d="`M${svgPadding} ${svgHeight / 2 - spreadYOffsetCalculatedA()} 
                   L${svgPadding + 116} ${
            svgHeight / 2 - spreadYOffsetCalculatedA()
          } 
                   L${svgPadding + 116 + spreadXOffset} ${
            svgHeight / 2 - 4 * fiberHeight
          } 
                   L${svgWidth / 2} ${svgHeight / 2 - 4 * fiberHeight}`"
          style="fill: none; stroke-width: 2; stroke: green"
        />
      </g>

      <g v-if="!(isPigtail === true)" class="fiber-1-side-b">
        <path
          :d="` M${svgWidth / 2} ${svgHeight / 2 - 4 * fiberHeight} 
                    L${svgWidth - (svgPadding + 116 + spreadXOffset)} ${
            svgHeight / 2 - 4 * fiberHeight
          } 
                    L${svgWidth - (svgPadding + 116)} ${
            svgHeight / 2 - spreadYOffsetCalculatedB()
          } 
                    L${svgWidth - svgPadding} ${
            svgHeight / 2 - spreadYOffsetCalculatedB()
          } `"
          style="fill: none; stroke-width: 2; stroke: green"
        />
      </g>

      <g class="fiber-2-side-a">
        <!-- spread -->
        <path
          :d="` M${svgPadding} ${svgHeight / 2 + spreadYOffsetCalculatedA()} 
                    L${svgPadding + 116} ${
            svgHeight / 2 + spreadYOffsetCalculatedA()
          } 
                    L${svgPadding + 116 + spreadXOffset} ${
            svgHeight / 2 + 4 * fiberHeight
          } 
                    L${svgWidth / 2} ${svgHeight / 2 + 4 * fiberHeight} `"
          style="fill: none; stroke-width: 2; stroke: rgb(223, 168, 39)"
        />
      </g>

      <g v-if="!(isPigtail === true)" class="fiber-2-side-b">
        <!-- spread -->
        <path
          :d="` M${svgWidth / 2} ${svgHeight / 2 + 4 * fiberHeight} 
                    L${svgWidth - (svgPadding + 116 + spreadXOffset)} ${
            svgHeight / 2 + 4 * fiberHeight
          } 
                    L${svgWidth - (svgPadding + 116)} ${
            svgHeight / 2 + spreadYOffsetCalculatedB()
          } 
                    L${svgWidth - svgPadding} ${
            svgHeight / 2 + spreadYOffsetCalculatedB()
          } `"
          style="fill: none; stroke-width: 2; stroke: rgb(223, 168, 39)"
        />
      </g>
    </g>

    <!-- claddings -->
    <g class="claddings">
      <!-- unspread -->
      <g class="cladding-1-side-a">
        <!--spread -->
        <path
          :d="` M${svgPadding + 55} ${
            svgHeight / 2 - spreadYOffsetCalculatedA() + 1
          } 
                    L${svgPadding + 116} ${
            svgHeight / 2 - spreadYOffsetCalculatedA() + 1
          } 
                    L${svgPadding + 116 + spreadXOffset} ${
            svgHeight / 2 - 4 * fiberHeight
          } 
                    L${svgWidth / 2} ${svgHeight / 2 - 4 * fiberHeight} `"
          style="fill: none; stroke-width: 5; stroke: #ccbe82"
        />
      </g>

      <g v-if="!(isPigtail === true)" class="cladding-1-side-b">
        <!--spread -->
        <path
          :d="` M${svgWidth / 2} ${svgHeight / 2 - 4 * fiberHeight} 
                    L${svgWidth - (svgPadding + 116 + spreadXOffset)} ${
            svgHeight / 2 - 4 * fiberHeight
          } 
                    L${svgWidth - (svgPadding + 116)} ${
            svgHeight / 2 - spreadYOffsetCalculatedB() + 1
          } 
                    L${svgWidth - (svgPadding + 55)} ${
            svgHeight / 2 - spreadYOffsetCalculatedB() + 1
          } `"
          style="fill: none; stroke-width: 5; stroke: #ccbe82"
        />
      </g>

      <g class="cladding-2-side-a">
        <!--spread -->
        <path
          :d="` M${svgPadding + 55} ${
            svgHeight / 2 + spreadYOffsetCalculatedA() - 1
          } 
                    L${svgPadding + 116} ${
            svgHeight / 2 + spreadYOffsetCalculatedA() - 1
          } 
                    L${svgPadding + 116 + spreadXOffset} ${
            svgHeight / 2 + 4 * fiberHeight
          } 
                    L${svgWidth / 2 + 5} ${svgHeight / 2 + 4 * fiberHeight} `"
          style="fill: none; stroke-width: 5; stroke: #ccbe82"
        />
      </g>

      <g v-if="!(isPigtail === true)" class="cladding-2-side-b">
        <!-- spread -->
        <path
          :d="` M${svgWidth / 2} ${svgHeight / 2 + 4 * fiberHeight} 
                    L${svgWidth - (svgPadding + 116 + spreadXOffset)} ${
            svgHeight / 2 + 4 * fiberHeight
          } 
                    L${svgWidth - (svgPadding + 116)} ${
            svgHeight / 2 + spreadYOffsetCalculatedB() - 1
          } 
                    L${svgWidth - (svgPadding + 55)} ${
            svgHeight / 2 + spreadYOffsetCalculatedB() - 1
          } `"
          style="fill: none; stroke-width: 5; stroke: #ccbe82"
        />
      </g>

      <g class="cladding-1-and-2-side-b" v-if="isPigtail">
        <!-- upper fiber -->
        <path
          :d="` M${svgWidth / 2} ${svgHeight / 2 - 4 * fiberHeight} L${
            svgWidth - svgPadding
          } ${svgHeight / 2 - 4 * fiberHeight}`"
          fill="none"
          stroke-width="5"
          stroke="#ccbe82"
        />
        <!-- lower fiber -->
        <path
          :d="` M${svgWidth / 2} ${svgHeight / 2 + 4 * fiberHeight} L${
            svgWidth - svgPadding
          } ${svgHeight / 2 + 4 * fiberHeight} `"
          fill="none"
          stroke-width="5"
          stroke="#ccbe82"
        />
      </g>
    </g>

    <!-- cloak -->
    <g class="cloak">
      <g class="cloak-side-a">
        <!-- spread -->
        <path
          :d="` M${svgPadding + 55 + 5} ${
            svgHeight / 2 - spreadYOffsetCalculatedA() + 2 - 1
          } 
                    L${svgPadding + 116 + 3} ${
            svgHeight / 2 - spreadYOffsetCalculatedA() + 2 - 1
          } 
                    L${svgPadding + 116 + spreadXOffset} ${
            svgHeight / 2 - 4 * fiberHeight
          } 
                    L${svgWidth / 2} ${svgHeight / 2 - 4 * fiberHeight} `"
          fill="none"
          stroke-width="7"
          :stroke="getCssColor(cableColor)"
        />
        <!-- lower fiber -->
        <path
          :d="` M${svgPadding + 55 + 5} ${
            svgHeight / 2 + spreadYOffsetCalculatedA() - 1
          } 
                    L${svgPadding + 116} ${
            svgHeight / 2 + spreadYOffsetCalculatedA() - 1
          } 
                    L${svgPadding + 116 + spreadXOffset} ${
            svgHeight / 2 + 4 * fiberHeight
          } 
                    L${svgWidth / 2 + 5} ${svgHeight / 2 + 4 * fiberHeight} `"
          fill="none"
          stroke-width="7"
          :stroke="getCssColor(cableColor)"
        />
      </g>

      <g class="cloak-side-b" v-if="!isPigtail">
        <!-- upper fiber -->
        <path
          :d="` M${svgWidth / 2} ${svgHeight / 2 - 4 * fiberHeight} 
                    L${svgWidth - (svgPadding + 116 + spreadXOffset)} ${
            svgHeight / 2 - 4 * fiberHeight
          } 
                    L${svgWidth - (svgPadding + 116 + 3)} ${
            svgHeight / 2 - spreadYOffsetCalculatedB() + 2 - 1
          } 
                    L${svgWidth - (svgPadding + 55 + 5)} ${
            svgHeight / 2 - spreadYOffsetCalculatedB() + 2 - 1
          } `"
          fill="none"
          stroke-width="7"
          :stroke="getCssColor(cableColor)"
        />
        <!-- lower fiber -->
        <path
          :d="` M${svgWidth / 2} ${svgHeight / 2 + 4 * fiberHeight} 
                    L${svgWidth - (svgPadding + 116 + spreadXOffset)} ${
            svgHeight / 2 + 4 * fiberHeight
          } 
                    L${svgWidth - (svgPadding + 116 + 3)} ${
            svgHeight / 2 + spreadYOffsetCalculatedB() - 2 + 1
          } 
                    L${svgWidth - (svgPadding + 55 + 5)} ${
            svgHeight / 2 + spreadYOffsetCalculatedB() - 2 + 1
          } `"
          fill="none"
          stroke-width="7"
          :stroke="getCssColor(cableColor)"
        />
      </g>

      <g class="cloak-side-b" v-if="isPigtail">
        <!-- upper fiber -->
        <path
          :d="` M${svgWidth / 2} ${svgHeight / 2 - 4 * fiberHeight} L${
            svgWidth - (svgPadding + 5)
          } ${svgHeight / 2 - 4 * fiberHeight}`"
          fill="none"
          stroke-width="7"
          :stroke="getCssColor(cableColor)"
        />
        <!-- lower fiber -->
        <path
          :d="` M${svgWidth / 2} ${svgHeight / 2 + 4 * fiberHeight} L${
            svgWidth - (svgPadding + 5)
          } ${svgHeight / 2 + 4 * fiberHeight} `"
          fill="none"
          stroke-width="7"
          :stroke="getCssColor(cableColor)"
        />
      </g>
    </g>
  </g>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      fiberHeight: 1,
      claddingHeight: 3,
      cloakHeight: 13,
      spreadXOffset: 20,
      spreadYOffset: 10,
      wideSpreaders: ["FC", "ST", "SC", "FC Narrow Key", "FSMA 905 Rändel"],
    };
  },
  props: {
    svgHeight: Number,
    svgWidth: Number,
    svgPadding: {
      type: Number,
      default: 20,
    },
    svgCladdingMargin: {
      type: Number,
      default: 30,
    },
    svgCloakMargin: {
      type: Number,
      default: 35,
    },
    cableColor: String,

    isPigtail: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // cloak color based on cable color selection
    cloakStyle() {
      let color = this.getCssColor(this.cableColor);
      return `fill: ${color}; stroke-width: 1; stroke: ${color};`;
    },
    ...mapGetters({
      getCssColor: "getCssColor",
      getPropertyValueFor: "selectedValue",
    }),
  },
  methods: {
    spreadYOffsetCalculatedA() {
      return this.isWideSpreadSideA() === true
        ? this.spreadYOffset + 3
        : this.spreadYOffset - 1;
    },
    spreadYOffsetCalculatedB() {
      return this.isWideSpreadSideB() === true
        ? this.spreadYOffset + 3
        : this.spreadYOffset - 1;
    },
    isWideSpreadSideA() {
      return this.wideSpreaders.includes(
        this.getPropertyValueFor("plugsA", "plugType")
      );
    },
    isWideSpreadSideB() {
      return this.wideSpreaders.includes(
        this.getPropertyValueFor("plugsB", "plugType")
      );
    },
  },
};
</script>
